import instance from "../../URL/index";
const axios = instance.axios;

export default {
    services: {
        /** Get Tags Options by type (only the tags owned by the supplier)
         * @param {string} type - The tag type
         * @param {string} token - The session token
         * @returns {Promise} - The Axios promise
         */
        getTagsOptionsByType: (type, token = "") => {
            return axios(token).get(`/tags-options?type=${type}`);
        },
        /** Create Tag (owned by the supplier)
         * @param {Object} payload - The tag data
         * @param {string} token - The session token
         * @returns {Promise} - The Axios promise
         */
        createTag: (payload, token = "") => {
            return axios(token).post(`/tags`, payload);
        },
        /** Delete Tag (only tags owned by the supplier)
         * @param {string} tagId - The ID of the tag
         * @param {string} token - The session token
         * @returns {Promise} - The Axios promise
         */
        deleteTagById: (tagId, token = "") => {
            return axios(token).delete(`/tags/${tagId}`);
        }
    }
};
